import { pivotLongFormToWide } from '../transforms/pivotLongFormToWide';
import type { TransformRow } from '../transforms/types';
import { assertRequiredColumns } from './assertRequiredColumns';
import type { LineOrBarAdapterConfig } from './types';
import { RenderAdapterError } from './types';

export function requiredColumnsForLineOrBar(
  config: LineOrBarAdapterConfig,
): string[] {
  if (config.pivotBy) {
    return Array.from(
      new Set([
        config.pivotBy.dimension,
        config.pivotBy.indexBy,
        config.pivotBy.measure,
        config.xAxisKey,
        ...(config.pivotBy.displayBy ? [config.pivotBy.displayBy] : []),
      ]),
    );
  }
  return [config.xAxisKey, ...config.series];
}

export function lineOrBarWideRows(
  rows: TransformRow[],
  config: LineOrBarAdapterConfig,
): { rows: TransformRow[] } | { error: RenderAdapterError } {
  const columnError = assertRequiredColumns(
    rows,
    requiredColumnsForLineOrBar(config),
  );
  if (columnError) {
    return { error: columnError };
  }
  const wide = config.pivotBy
    ? pivotLongFormToWide(rows, config.pivotBy)
    : rows;
  return { rows: wide };
}
